// src/layouts/PaidProjectLayout.jsx

import React, { useEffect, useState } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
// import PaidProjectNavbar from "../components/PaidProjectNavbar";
import API from "../api";
import Navbar from "../components/Navbar";

export default function PaidProjectLayout() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState(null);

  useEffect(() => {
    const fromState = location.state?.project;
    if (fromState) {
      setProject(fromState);
      // we don’t return, so we still fire the fetch below
    }

    API.get(`/user/projects/${projectId}`)
      .then(({ data }) => {
        // Allow both paid and unpaid projects here
        setProject(data);
      })
      .catch((err) => {
        console.error(err);
        navigate("/user/dashboard", { replace: true });
      })
      .finally(() => setLoading(false));
  }, [location.state, projectId, navigate]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Box component="main" flexGrow={1} p={2}>
        <Outlet context={{ project }} />
      </Box>
    </Box>
  );
}
